/**
 * Team Creation & Edit Tour Step Definitions.
 * Declarative, engine-agnostic configuration for the Team Form guide.
 */
export const teamFormTourConfig = {
  id: 'team-form-onboarding',
  storageKey: 'triad_tour_team_form_completed',
  steps: [
    {
      id: 'team-name',
      target: '[data-tour="team-name"]',
      titleKey: 'tour.teamForm.nameTitle',
      descriptionKey: 'tour.teamForm.nameDesc',
      position: 'bottom',
      align: 'start'
    },
    {
      id: 'team-description',
      target: '[data-tour="team-description"]',
      titleKey: 'tour.teamForm.descTitle',
      descriptionKey: 'tour.teamForm.descDesc',
      position: 'bottom',
      align: 'start'
    },
    {
      id: 'team-parent',
      target: '[data-tour="team-parent"]',
      titleKey: 'tour.teamForm.parentTitle',
      descriptionKey: 'tour.teamForm.parentDesc',
      position: 'bottom',
      align: 'start'
    },
    {
      id: 'team-save-btn',
      target: '[data-tour="team-save-btn"]',
      titleKey: 'tour.teamForm.saveTitle',
      descriptionKey: 'tour.teamForm.saveDesc',
      position: 'bottom',
      align: 'end'
    }
  ]
};

export default teamFormTourConfig;
